import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import {
    FiGrid, FiUsers, FiLayers, FiActivity,
    FiShield, FiLogOut, FiChevronLeft,
    FiZap, FiX
} from 'react-icons/fi';

const NAV = [
    { to: '/',      icon: FiGrid,     label: 'Dashboard'      },
    { to: '/orgs',  icon: FiLayers,   label: 'Organisations'  },
    { to: '/users', icon: FiUsers,    label: 'Utilisateurs'   },
    { to: '/logs',  icon: FiActivity, label: 'Logs d\'audit'  },
];

const Sidebar = ({ mobileOpen, setMobileOpen }) => {
    const { user, logout } = useAuth();
    const navigate = useNavigate();
    const [collapsed, setCollapsed] = useState(false);

    const handleLogout = () => { logout(); navigate('/login'); };
    const closeMobile = () => setMobileOpen(false);

    return (
        <>
            {/* Backdrop mobile */}
            {mobileOpen && (
                <div
                    className="fixed inset-0 z-40 bg-black/60 md:hidden"
                    onClick={closeMobile}
                />
            )}

            <aside className={`
                flex flex-col bg-gray-900 border-r border-gray-800 transition-all duration-200 shrink-0
                fixed inset-y-0 left-0 z-50
                ${mobileOpen ? 'translate-x-0' : '-translate-x-full'}
                md:static md:translate-x-0
                ${collapsed ? 'w-16' : 'w-56'}
            `}>
                {/* Logo */}
                <div className={`flex items-center h-16 border-b border-gray-800 px-3 ${collapsed ? 'justify-center' : 'gap-2.5'}`}>
                    <div
                        className={`w-8 h-8 rounded-lg bg-brand-600 flex items-center justify-center shrink-0 ${collapsed ? 'cursor-pointer hover:bg-brand-500 transition-colors' : ''}`}
                        onClick={collapsed ? () => setCollapsed(false) : undefined}
                        title={collapsed ? 'Agrandir' : undefined}
                    >
                        <FiZap size={16} className="text-white" aria-hidden="true" />
                    </div>
                    {!collapsed && (
                        <>
                            <div className="flex-1 min-w-0">
                                <span className="text-white font-bold text-sm">PulseCIO</span>
                                <span className="block text-brand-400 text-xs font-semibold -mt-0.5">Admin</span>
                            </div>
                            {/* Bouton fermer (mobile) */}
                            <button
                                onClick={closeMobile}
                                className="p-1.5 rounded-lg text-gray-500 hover:text-gray-300 hover:bg-gray-800 transition-colors shrink-0 md:hidden"
                                title="Fermer"
                            >
                                <FiX size={15} aria-hidden="true" />
                            </button>
                            {/* Bouton réduire (desktop) */}
                            <button
                                onClick={() => setCollapsed(true)}
                                className="p-1.5 rounded-lg text-gray-500 hover:text-gray-300 hover:bg-gray-800 transition-colors shrink-0 hidden md:block"
                                title="Réduire"
                            >
                                <FiChevronLeft size={15} aria-hidden="true" />
                            </button>
                        </>
                    )}
                </div>

                {/* Nav */}
                <nav className="flex-1 px-2 py-4 space-y-1">
                    {NAV.map(({ to, icon: Icon, label }) => (
                        <NavLink
                            key={to}
                            to={to}
                            end={to === '/'}
                            onClick={closeMobile}
                            className={({ isActive }) =>
                                `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors group ${
                                    isActive
                                        ? 'bg-brand-600 text-white'
                                        : 'text-gray-400 hover:text-white hover:bg-gray-800'
                                } ${collapsed ? 'justify-center' : ''}`
                            }
                            title={collapsed ? label : undefined}
                        >
                            <Icon size={17} className="shrink-0" aria-hidden="true" />
                            {!collapsed && <span>{label}</span>}
                        </NavLink>
                    ))}
                </nav>

                {/* Footer */}
                <div className="border-t border-gray-800 p-3 space-y-2">
                    {!collapsed && user && (
                        <div className="px-2 py-2 rounded-lg bg-gray-800">
                            <div className="flex items-center gap-2">
                                <div className="w-7 h-7 rounded-full bg-brand-600 flex items-center justify-center text-white text-xs font-bold shrink-0">
                                    {(user.name || 'A')[0].toUpperCase()}
                                </div>
                                <div className="min-w-0">
                                    <div className="text-white text-xs font-medium truncate">{user.name}</div>
                                    <div className="flex items-center gap-1">
                                        <FiShield size={10} className="text-brand-400" aria-hidden="true" />
                                        <span className="text-brand-400 text-xs">Super Admin</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    <button
                        onClick={handleLogout}
                        className={`flex items-center gap-2 px-3 py-2 rounded-lg text-gray-400 hover:text-red-400 hover:bg-gray-800 text-sm transition-colors w-full ${collapsed ? 'justify-center' : ''}`}
                        title="Se déconnecter"
                    >
                        <FiLogOut size={16} aria-hidden="true" />
                        {!collapsed && <span>Déconnexion</span>}
                    </button>
                </div>
            </aside>
        </>
    );
};

export default Sidebar;
